{
  "branding": {
    "frontdesk-attribution": "FrontDesk+ を使用",
    "practice-logo": "{{name}}のロゴ"
  },
  "validation": {
    "required": "このフィールドは必須です",
    "invalid-url": "有効なURLを入力してください",
    "pin-too-short": "PINは最低4文字必要です",
    "pin-default-rejected": "標準の PIN 0000 は使用できません。独自の PIN を割り当ててください。",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "戻る",
    "next": "次へ",
    "cancel": "キャンセル",
    "confirm": "確認",
    "done": "完了",
    "retry": "再試行",
    "clear": "クリア",
    "close": "閉じる",
    "verifying": "確認中...",
    "select": "選択",
    "minutes": "分",
    "clock": "",
    "gender": {
      "M": "男性",
      "W": "女性",
      "D": "多様",
      "U": "不明"
    },
    "insurance": {
      "GKV": "法定",
      "PKV": "民間",
      "SELFPAY": "自費"
    },
    "scroll-up": "上にスクロール",
    "scroll-down": "下にスクロール"
  },
  "settings": {
    "device-reset": {
      "title": "端末をリセット",
      "description": "この端末の診療所への接続、端末設定、PINを削除します。",
      "confirmation": "この端末の再設定が必要になります。SOLの設定とinSuiteの患者データは変更されません。",
      "cancel": "キャンセル",
      "confirm": "今すぐリセット"
    },
    "title": "設定",
    "save": "保存",
    "save-success": "設定を保存しました",
    "save-error": "設定の保存に失敗しました",
    "load-error": "設定の読み込みに失敗しました",
    "pin": {
      "title": "PIN必須",
      "description": "設定にアクセスするにはPINを入力してください。",
      "error": "PINが間違っています。もう一度お試しください。",
      "backspace": "最後の数字を削除"
    },
    "connection": {
      "title": "接続",
      "description": "Doc-Cirrus Bridgeサーバーの接続設定",
      "bridge-url": "Bridge URL",
      "device-name": "デバイス名",
      "device-name-placeholder": "例:フロント、ルーム 1、キオスク",
      "device-name-hint": "Bridgeダッシュボードで識別するための名前",
      "kim-address": "KIM アドレス (オプション)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "テスト",
      "success": "接続成功",
      "error": "接続失敗",
      "api-unreachable": "DocCirrus API に到達できません",
      "status-title": "接続ステータス",
      "status": {
        "api": "API接続済み",
        "ti": "テレマティクスインフラストラクチャ",
        "card-reader": "カードリーダーが利用可能",
        "medical-card": "医療機関カード (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol トークン（inSuite から）",
      "sol-token-hint": "inSuite の Bridge 管理からコピーしてください。接続に必要です。",
      "sol-token-show": "トークンを表示",
      "sol-token-hide": "トークンを隠す",
      "bridge-unreachable": "Bridge に接続できません。アドレスとポートを確認してください。",
      "diagnostic-id": "診断 ID: {{id}}",
      "scan-qr": "QR コードをスキャン",
      "scan-title": "Bridge の QR コードをスキャン",
      "scan-manual": "手動で入力"
    },
    "terminal": {
      "title": "カードリーダー",
      "description": "遠隔医療インフラ用のカードリーダーの選択",
      "select": "ターミナルを選択",
      "select-placeholder": "ターミナルを選択...",
      "loading": "ターミナルを読み込み中...",
      "none-available": "利用可能なターミナルがありません",
      "none-found": "ターミナルが見つかりません",
      "found": "{{count}}個のターミナルが見つかりました",
      "connect-hint": "ターミナルを読み込むには、まずbridgeサーバーに接続してください。",
      "found-count": "見つかったカードリーダー: {{count}}",
      "refresh": "カードリーダーを再読み込み"
    },
    "practice": {
      "title": "医療機関",
      "description": "医療機関に関する情報",
      "name": "医療機関名",
      "name-placeholder": "例：田中医師",
      "welcome-message": "ウェルカムメッセージ",
      "welcome-placeholder": "例: 当院へようこそ",
      "scheduler-available": "スケジューラを有効にする",
      "scheduler-available-description": "患者がセルフサービス端末を通じて予約できるようにする",
      "prescription-available": "処方箋サービスを有効にする",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "空欄にすると、患者の言語で挨拶が表示されます。独自の文章はどの言語でもそのまま表示されます。"
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "全デバイスに保存済み: {{value}}",
      "never-saved-default": "既定の設定（未変更）"
    },
    "anamnesis": {
      "title": "デジタル病歴",
      "description": "チェックイン後に病歴プロバイダーへのリンクと QR code が表示されます。",
      "enabled": "チェックイン後に病歴リンクを表示する",
      "enabled-description": "チェックインが完了した後、病歴プロバイダーへのリンクと QR code (Nelly など) が表示されます。",
      "url": "病歴プロバイダーのリンク",
      "url-hint": "リンクは静的であり、すべての患者に対して同一です。",
      "preview-label": "完了画面プレビュー",
      "preview-note": "リンクは静的であり、すべての患者に対して同一です。",
      "url-first": "オンにするには、まず有効なリンクを入力してください。"
    },
    "appearance": {
      "title": "外観",
      "description": "ユーザーインターフェースのカスタマイズ",
      "language": "言語",
      "default-kiosk-language": "デフォルトの患者言語",
      "default-kiosk-language-hint": "患者向けに新しいキオスク セッションが開始される言語。",
      "voice-over-volume": "ナレーションの音量",
      "voice-over-hint": "アクセシビリティのためにナレーション アシスタントの音量を制御します。",
      "language-first": "セッション開始時に言語選択を表示"
    },
    "security": {
      "title": "セキュリティ",
      "description": "設定アクセス用のPIN",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "キオスク管理",
    "nav": {
      "general": "一般",
      "flows": "機能",
      "anamnese": "デジタル問診",
      "device": "デバイスと接続"
    },
    "flows": {
      "title": "端末の機能"
    },
    "language": {
      "title": "言語と音声",
      "description": "このデバイスで患者向けに使う言語と読み上げ。"
    }
  },
  "self-service": {
    "title": "セルフサービス",
    "step-progress": "ステップ {{current}} / {{total}}",
    "flows": {
      "checkin": "チェックイン",
      "scheduler": "予約する",
      "prescription": "処方箋",
      "locations": "場所マップ",
      "emergency": "緊急"
    },
    "audio-guide": {
      "on": "音声オン",
      "off": "音声オフ",
      "replay": "音声案内をもう一度再生",
      "replay-unavailable": "再生できる音声案内はありません"
    },
    "language-selector": {
      "title": "言語を選択",
      "description": "ご希望の言語を選択してください"
    },
    "settings": "設定",
    "start": {
      "welcome": "ようこそ",
      "subtitle": "オプションを選択してください",
      "check-in-label": "メインパス",
      "check-in-cta": "チェックイン",
      "check-in-description": "すでに予約がありますか？こちらでチェックインしてください。",
      "check-in-hint": "カードをご用意ください",
      "scheduler-label": "新しい",
      "scheduler-cta": "予約する",
      "scheduler-description": "新しい予約を取ります。",
      "location-plan": "場所マップ",
      "location-plan-description": "診察室への道を見つけます。",
      "prescription-label": "処方箋",
      "prescription-cta": "処方箋と注文",
      "prescription-description": "処方箋を表示したり、補充品を注文したりできます。",
      "emergency-cta": "端末内の緊急アラーム",
      "emergency-description": "この端末だけで鳴り、救助要請は行いません。",
      "tap-to-start": "タップして開始"
    },
    "offline": {
      "banner-title": "チェックインは一時的に利用できません",
      "banner-message": "フロントスタッフにお問い合わせください。",
      "emergency-available": "端末内のアラームは引き続き利用できます。救助要請は行いません。",
      "flow-disabled": "一時的に利用できません"
    },
    "readability": {
      "toggle-label": "読み取りモード",
      "on": "読み取りモード",
      "off": "読み取りモード"
    },
    "reset-overlay": {
      "timeout-title": "セッションが終了しました",
      "timeout-subtitle": "期限が切れました。あなたのデータは安全です。",
      "offline-title": "接続が失われました",
      "offline-subtitle": "接続が中断されました。受付スタッフにお声がけください。",
      "interruption-title": "セッションが終了しました",
      "interruption-subtitle": "セッションは安全に終了しました。",
      "completion-title": "ありがとうございます！",
      "completion-subtitle": "リクエストは正常に完了しました。",
      "reassurance": "あなたの個人データはこのデバイスには保存されません。",
      "auto-dismiss": "{{seconds}} 秒後にスタートに戻ります...",
      "dismiss": "開始へ移動"
    },
    "timed-terminal": {
      "countdown": "{{seconds}} 秒で自動復帰",
      "countdown-outcome": "本端末は自動的にスタート画面に戻ります。",
      "more-time": "より多くの時間を",
      "extended": "時間延長"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "これらの質問はご利用の言語では表示できません。表示されている言語を選ぶか、受付にお問い合わせください。",
        "alternatives": "別の予約候補",
        "loading": "質問を読み込み中…",
        "reception-fallback": "受付へお越しください。",
        "error-title": "質問を読み込めませんでした",
        "language-unavailable-lead": "これらの質問はご希望の言語では利用できません。",
        "language-unavailable-title": "次の言語から選択してください",
        "language-unavailable-body": "または受付でお手伝いを受けてください。"
      },
      "start": {
        "title": "予約する",
        "subtitle": "数ステップでご希望の予約を取ります",
        "welcome": "予約システムへようこそ",
        "description": "予約プロセスをご案内します",
        "cta": "今すぐ予約"
      },
      "patient-id": {
        "title": "身元確認",
        "subtitle": "身元を確認してください",
        "mode-card": "カードで",
        "mode-search": "検索",
        "mode-create": "新規作成",
        "insert-card": "健康保険カードを挿入してください",
        "reading-card": "カード読み取り中...",
        "simulate-card": "カードをシミュレート",
        "multiple-matches": "複数の患者が見つかりました。カードデータを使用します。",
        "search-placeholder": "名前または保険番号...",
        "searching": "検索中...",
        "no-results": "結果が見つかりません",
        "first-name": "名",
        "last-name": "姓",
        "dob": "生年月日",
        "insurance": "保険",
        "continue": "続行",
        "creating": "患者を作成しています...",
        "patient-created": "患者が正常に作成されました。",
        "create-error": "患者を作成できませんでした。"
      },
      "appointment-type": {
        "title": "予約タイプを選択",
        "subtitle": "来院理由を選択してください",
        "loading": "予約タイプを読み込み中...",
        "no-types": "利用可能な予約タイプがありません",
        "error": "予約タイプを読み込めません。もう一度お試しください。",
        "no-bookable": "これらの予約種別は現在キオスクでは予約できません。受付にお申し出いただくか、電話で予約してください。",
        "disabled-default": "この予約は受付で直接、または電話でお取りください。",
        "disabled-footer": "受付/電話のみ",
        "lead": "どの種類の予約をしますか？",
        "duration": "約 {{minutes}} 分",
        "empty-title": "現在ここでは予約できません",
        "none-bookable-title": "これらの予約はここではできません",
        "none-bookable-body": "受付でお尋ねいただくか、お電話ください。"
      },
      "types": {
        "general": "一般診察",
        "general-desc": "一般的な症状や質問",
        "checkup": "予防検診",
        "checkup-desc": "定期健康診断",
        "vaccination": "予防接種",
        "vaccination-desc": "予防接種の予約",
        "followup": "フォローアップ",
        "followup-desc": "フォローアップ予約",
        "prescription": "処方箋",
        "prescription-desc": "処方箋の受け取り"
      },
      "slot-selection": {
        "title": "予約を選択",
        "subtitle": "利用可能な予約を選択してください",
        "loading": "利用可能な予約を読み込み中...",
        "no-slots": "利用可能な予約がありません",
        "no-appointment-type": "予約タイプが選択されていません",
        "error": "利用可能なスロットを読み込めません。もう一度お試しください。",
        "quick-select": "次の利用可能な予約：",
        "select-date": "または日付を選択：",
        "times-for": "{{date}}",
        "available": "利用可能",
        "unavailable": "予約なし",
        "slots": "スロット",
        "select-time-hint": "予約するには時間をタップしてください",
        "week-short": "週",
        "weekday-mon": "月",
        "weekday-tue": "火",
        "weekday-wed": "水",
        "weekday-thu": "木",
        "weekday-fri": "金",
        "weekday-sat": "土",
        "weekday-sun": "日",
        "period-morning": "午前",
        "period-midday": "正午",
        "period-afternoon": "午後",
        "period-evening": "夕方",
        "period-morning-short": "午前",
        "period-midday-short": "正午",
        "period-afternoon-short": "午後",
        "period-evening-short": "夕方",
        "period-dots-legend": "時間の空き状況",
        "filter-hint": "希望時間でフィルター：",
        "or-choose-below": "または以下から選択してください",
        "no-slots-period": "スロットなし",
        "show-all": "すべて表示",
        "free": "無料",
        "your-selection": "あなたの選択",
        "oclock": "時",
        "choose-slot": "スロットを選択してください",
        "choose-day": "日付を選択",
        "choose-day-first": "まず日付を選択してください",
        "times-heading": "{{date}} の空き時間",
        "time-value": "{{time}}",
        "empty-title": "{{month}} に空きはありません",
        "empty-body": "翌月をご覧いただくか、受付でお尋ねください。喜んでお手伝いします。",
        "next-month": "翌月",
        "previous-month": "前月"
      },
      "confirmation": {
        "patient-responses": "ご回答",
        "review-loading": "概要を確認しています…",
        "review-unavailable": "概要を表示できません。もう一度お試しいただくか、受付でお尋ねください。",
        "check-booking": "予約状況を確認",
        "title": "予約を確認",
        "subtitle": "予約内容を確認してください",
        "patient": "患者",
        "datetime": "日時",
        "booking": "予約中...",
        "confirm": "予約する",
        "heading": "これは正しいように見えますか?",
        "lead": "予定をご確認ください。",
        "appointment": "予約",
        "insured-via": "を通じて保険に加入",
        "description-label": "クリニックへのメモ（任意）",
        "description-hint": "予約やチェックイン時に配慮が必要なことがあればお知らせください。",
        "description-placeholder": "例：移動の制限、付き添い、重要な注意事項",
        "description-too-long": "メモは500文字以内にしてください。",
        "summary": "概要",
        "change": "変更",
        "book-binding": "予約する",
        "cancel": "キャンセル",
        "type-label": "予約の種類",
        "datetime-value": "{{date}} {{time}}",
        "name-label": "お名前",
        "insurance-label": "保険",
        "insurance-GKV": "公的医療保険",
        "insurance-PKV": "民間医療保険",
        "insurance-SELFPAY": "自費",
        "change-time": "予約を変更",
        "description-free-text": "その他のご要望（任意）",
        "note-wheelchair": "車いすを使用しています",
        "note-companion": "付き添いの人と来ます",
        "note-interpreter": "通訳が必要です"
      },
      "done": {
        "title": "予約完了！",
        "label": "予約済み",
        "subtitle": "予約が正常に完了しました。",
        "date": "日付",
        "time": "時間",
        "booking-id": "予約番号",
        "qr-hint": "カレンダーに追加",
        "qr-description": "スマートフォンのカメラでこのQRコードをスキャンして、カレンダーアプリに予約を追加してください",
        "auto-redirect": "まもなくスタートページにリダイレクトされます...",
        "auto-redirect-countdown": "{{seconds}}秒後にスタートに戻ります...",
        "back-to-start": "スタートに戻る",
        "print-button": "予約票を印刷",
        "print-preparing": "印刷画面を準備しています…",
        "print-error": "予約票を開けませんでした。もう一度お試しいただくか、受付にお尋ねください。",
        "print-returned": "システムの印刷画面を閉じました。必要な場合は、もう一部印刷できます。",
        "print-title": "ご予約",
        "print-location": "場所",
        "print-map-hint": "スマートフォンで場所を開く",
        "print-error-v2": "予約票を開けませんでした。もう一度お試しいただくか、受付でお尋ねください。"
      },
      "error": {
        "assistance-info": "予約を確認できませんでした。すでに予約が完了している可能性があります。受付でお尋ねください。",
        "pending-title": "予約は確認されていません",
        "pending-info": "予約を確認できませんでした。すでに予約が完了している可能性があります。もう一度確認するか、受付でお尋ねください。",
        "title": "予約失敗",
        "subtitle": "予約できませんでした。",
        "info": "もう一度お試しいただくか、受付でお尋ねください。"
      },
      "phase": {
        "identify": "受付",
        "choose": "時間の選択",
        "confirm": "確認"
      }
    },
    "prescription": {
      "start": {
        "title": "処方箋と注文",
        "subtitle": "保険カードを挿入して処方箋を表示したり、補充を注文したりできます。",
        "button": "カードを挿入します"
      },
      "card-check": {
        "loading": "カードリーダーを読み込んでいます...",
        "no-terminal": "カードリーダーが設定されていません",
        "no-terminal-hint": "スタッフまでお問い合わせください。",
        "insert-card": "カードを挿入してください",
        "insert-card-hint": "保険証をカードリーダーに挿入します。",
        "card-detected": "カードが検出されました",
        "reading": "読書カード…",
        "reading-hint": "しばらくお待ちください。",
        "error": "カード読み取りエラー",
        "retry": "もう一度試してください",
        "manual-lookup": "カードなしで続行",
        "load-error": "カードリーダーをロードできませんでした",
        "read-error": "カードを読み取れませんでした"
      },
      "patient-selection": {
        "title": "患者の選択",
        "subtitle": "複数の患者が見つかった。お名前を選択してください。",
        "try-again": "もう一度試してください",
        "try-again-hint": "再度カードを挿入してください"
      },
      "list": {
        "title": "あなたの処方箋",
        "for-patient": "{{name}}の処方箋",
        "loading": "処方箋を読み込んでいます...",
        "error-title": "読み込みエラー",
        "fetch-error": "処方箋をロードできませんでした",
        "back-home": "スタートに戻る",
        "done": "完了"
      },
      "detail": {
        "prescription-info": "処方箋情報",
        "date": "日付",
        "prescriber": "処方者",
        "comment": "注記",
        "medications": "薬",
        "form": "フォーム",
        "pack-size": "梱包サイズ",
        "manufacturer": "メーカー",
        "loading": "処方箋を読み込んでいます...",
        "fetch-error": "処方箋の詳細を読み込めませんでした",
        "back-to-list": "リストに戻る",
        "print": "印刷する"
      },
      "types": {
        "public": "公的処方箋",
        "private": "個人処方箋",
        "long-term": "長期処方",
        "btm": "麻薬の処方箋",
        "g": "緑の処方箋",
        "t": "T-処方箋"
      },
      "no-patient": {
        "title": "患者が見つからない",
        "subtitle": "残念ながら、このカードに該当する患者は見つかりませんでした。スタッフまでお問い合わせください。",
        "try-again": "もう一度試してください",
        "back-home": "スタートに戻る",
        "title-v2": "一致する情報が見つかりません",
        "subtitle-v2": "見つかりませんでした。もう一度お試しいただくか、受付でお尋ねください。"
      },
      "done": {
        "title": "ありがとう",
        "subtitle": "今からお座りください。ご不明な点がございましたらスタッフまでお問い合わせください。",
        "no-prescriptions-title": "ファイルに処方箋はありません",
        "no-prescriptions-subtitle": "あなたに有効な処方箋は見つかりませんでした。ご希望の場合は受付スタッフまでお申し付けください。",
        "error-title": "エラーが発生しました",
        "error-subtitle": "さらにサポートが必要な場合はスタッフにお問い合わせください。",
        "auto-redirect": "{{seconds}} 秒で自動リダイレクト",
        "finish": "スタートに戻る"
      },
      "hub": {
        "title": "あなたの処方箋",
        "for-patient": "{{name}}の処方箋",
        "loading": "処方箋を読み込んでいます...",
        "error-title": "読み込みエラー",
        "fetch-error": "処方箋を読み込めませんでした",
        "back-home": "スタートに戻る",
        "done": "完了",
        "order-button": "処方箋の注文",
        "existing-prescriptions": "現在の処方箋",
        "no-prescriptions": "有効な処方箋は見つかりませんでした。"
      },
      "patient-lookup": {
        "title": "患者を探す",
        "subtitle": "名前と生年月日を入力します。",
        "last-name": "姓",
        "first-name": "名",
        "date-of-birth": "生年月日",
        "lastname": "姓",
        "lastname-placeholder": "あなたの姓",
        "firstname": "名",
        "firstname-placeholder": "あなたの名前",
        "dob": "生年月日",
        "search": "検索",
        "searching": "検索中...",
        "search-error": "検索エラー:{{message}}",
        "no-match": "患者は見つかりませんでした。ご自身の情報をご確認ください。",
        "error": "検索エラー。もう一度試してください。",
        "found": "患者が見つかりました",
        "confirm": "確認する",
        "ambiguous": "複数の一致",
        "ambiguous-hint-firstname": "検索を絞り込むには、名も入力してください。",
        "ambiguous-hint-additional": "ご自身の情報をご確認いただくか、スタッフにお問い合わせください。",
        "not-found": "患者が見つからない",
        "not-found-hint": "これらの詳細を備えた患者は見つかりませんでした。",
        "not-found-action": "もう一度試してください"
      },
      "manual-identification": {
        "unverified": "健康保険証による本人確認は行われていません。診療所が処理前に入力内容と依頼を確認します。"
      },
      "medication-selection": {
        "title": "処方箋をリクエストする",
        "subtitle": "医療機関がリクエストを確認します。承認後、eRx は e-prescription アプリで準備完了になります。",
        "back": "戻る",
        "submit": "レビューを続ける",
        "reason-title": "なぜ処方箋が必要なのでしょうか？",
        "reason-hint": "医療機関がリクエストを評価するのに役立ちます。",
        "reason-validation": "理由を選択してください。",
        "reason-schmerzen": "痛み",
        "reason-entzuendung": "炎症",
        "reason-nachsorge": "手術・処置後",
        "reason-allergie": "アレルギー・反応",
        "reason-chronisch": "慢性状態",
        "reason-anderes": "何か他のもの",
        "medications-title": "どの薬ですか？",
        "request-hint": "必要なものを説明するか、更新したい以前の処方箋の名前を入力してください。",
        "request-placeholder": "例:イブプロフェン 600mg 前回と同じ",
        "request-validation": "必要なお薬をご記入ください。",
        "history-title": "以前の処方箋",
        "history-hint": "エントリを追加してリクエストを事前入力します。",
        "history-loading": "以前の処方箋を読み込んでいます...",
        "history-error": "以前の処方箋をロードできませんでした。",
        "history-add": "追加",
        "history-added": "追加されました",
        "history-date": "最後：{{date}}",
        "history-request-line": "更新:{{medicationName}}",
        "urgency-title": "どのくらい緊急ですか?",
        "urgency-hint": "医療機関が優先順位を判断するのに役立ちます。",
        "urgency-soon": "緊急",
        "urgency-soon-meta": "できるだけ早く",
        "urgency-tomorrow": "もうすぐ",
        "urgency-tomorrow-meta": "今後数日以内に",
        "urgency-week": "今週",
        "urgency-week-meta": "時間のプレッシャーがない",
        "lead": "医院が依頼を確認します。承認後、電子処方箋は電子処方箋アプリまたは健康保険証で確認できます。",
        "history-hint-v2": "以前の処方をタップすると追加できます。",
        "history-retry": "再読み込み"
      },
      "request-review": {
        "title": "注文の確認",
        "subtitle": "処方箋リクエストを確認してください。",
        "request-label": "要求された薬",
        "selected-medications": "選択された医薬品",
        "free-text-medications": "追加の薬",
        "freetext-label": "その他",
        "quarterly-warning": "今四半期に保険カードが読み取られていません。医療機関から連絡がある場合があります。",
        "egk-warning": "今四半期に保険カードが読み取られていません。医療機関から連絡がある場合があります。",
        "submit": "送信する",
        "submitting": "送信中...",
        "submit-error": "リクエストを送信できませんでした。もう一度試してください。",
        "back": "戻る",
        "reason-label": "理由",
        "urgency-label": "緊急性",
        "completion-email-choice": "診療所で依頼の処理が完了したら、メールを受け取りたいです。",
        "completion-email-label": "メールアドレス",
        "completion-email-placeholder": "name@example.com",
        "completion-email-hint": "この1回限りの通知にのみ使用します。基本情報として保存されません。",
        "completion-email-invalid": "有効なメールアドレスを入力してください。",
        "egk-proof-required": "処方依頼は保険証カードの読み取りが成功した後にのみ利用できます。スタッフにお声がけください。",
        "title-v2": "依頼の確認",
        "completion-email-hint-v2": "このアドレスはこの1回のお知らせにのみ使用されます。"
      },
      "confirmation": {
        "title": "リクエストを送信しました",
        "subtitle": "処方箋リクエストは正常に送信されました。",
        "success-title": "リクエストを送信しました",
        "success-subtitle": "処方箋リクエストは正常に送信されました。",
        "estimated-time": "処方箋は約 {{time}} で完成します。",
        "info": "保険証またはeRezeptアプリを使用して薬局で処方箋を受け取ることができます。",
        "auto-redirect": "{{seconds}} 秒で自動リダイレクト",
        "back-to-start": "スタートに戻る",
        "handling-label": "Handled by the practice",
        "next-steps": "医院が依頼を確認します。承認後、健康保険証または電子処方箋アプリを使って薬局で電子処方箋を利用できます。"
      },
      "phase": {
        "identify": "受付",
        "request": "依頼",
        "review": "確認"
      }
    },
    "check-in": {
      "flow-label": "チェックイン",
      "has-appointment": {
        "eyebrow": "予約",
        "title": "予約はありますか？",
        "subtitle": "オプションを選択してください",
        "yes-label": "はい",
        "yes": "はい、予約があります",
        "yes-description": "予約のチェックインをしたいです。",
        "yes-hint": "最速パス",
        "unsure-label": "たぶん",
        "unsure": "わかりません",
        "unsure-description": "確認いたします。",
        "unsure-hint": "私たちがあなたを探します",
        "no-label": "いいえ",
        "no": "いいえ、予約なし",
        "no-description": "予約がありません。",
        "no-hint": "ウォークイン"
      },
      "card-check": {
        "eyebrow": "保険証",
        "title": "健康保険カードを読み取る",
        "subtitle": "健康保険カードをリーダーに挿入してください",
        "insert-title": "保険証をカードリーダーに挿入してください。",
        "insert-detail": "あなたの詳細は自動的に読み取られます。他に何もする必要はありません。",
        "other-ways": "他の方法",
        "no-card-hint": "現在カードをお持ちでない場合。",
        "pkv-hint": "QR code を保険アプリで使用します。",
        "loading": "設定を読み込み中...",
        "no-terminal": "カードリーダーが設定されていません。スタッフにお問い合わせください。",
        "checking": "カードを確認中...",
        "insert-prompt": "カードを挿入してください...",
        "card-detected": "カードを検出しました！読み取り準備完了。",
        "read-card": "カードを読み取る",
        "simulate-insert": "カードをシミュレート",
        "reading": "カード読み取り中...",
        "error": "カードを読み取れません。もう一度お試しください。",
        "read-error": "カードデータの読み取りに失敗しました。もう一度お試しください。",
        "settings-error": "設定を読み込めません。もう一度お試しください。",
        "no-card-prompt": "カードをお持ちでないですか？",
        "no-card-action": "手動検索",
        "connection-warning": "カードリーダーとの接続の問題。お待ちください...",
        "pkv-prompt": "民間保険？Online Check-in",
        "pkv-instruction": "この QR code を民間の健康保険アプリでスキャンして、データをデジタル送信します。",
        "pkv-continue": "手動登録を続ける",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "もう一度お試しいただくか、カードなしで受付してください。受付スタッフがお手伝いします。",
        "title-pkv": "アプリで受付",
        "title-reading": "カードを読み取っています …",
        "title-unreadable": "カードを読み取れませんでした",
        "title-no-terminal": "カードなしで受付",
        "no-terminal-body": "カードリーダーは現在使用できません。カードなしで受付するか、受付窓口にお問い合わせください。",
        "reading-detail": "カードを差し込んだままにしてください。すぐに終わります。",
        "other-ways-title": "その他の方法",
        "no-card-title": "カードなしで受付",
        "pkv-prompt-title": "民間保険に加入していますか？",
        "pkv-prompt-hint": "民間医療保険のアプリで受付",
        "pkv-close": "やはりカードで受付",
        "pkv-instruction-app": "民間医療保険のアプリを開いて、このコードを読み取ってください。情報が直接当院に届きます。"
      },
      "patient-selection": {
        "title": "患者を選択",
        "subtitle": "複数の患者が見つかりました。ご自身を選択してください。",
        "firstname-label": "あなたの名前",
        "firstname-placeholder": "名を入力してください...",
        "confirm-button": "確認する",
        "no-match": "一致する患者が見つかりませんでした。フロントデスクまでお越しください。",
        "still-ambiguous": "複数の試合が残っています。フロントデスクまでお越しください。",
        "select-error": "患者の特定に失敗しました。もう一度試してください。",
        "staff-assist": "受付へ行く",
        "title-v2": "確認のお願い",
        "subtitle-v2": "念のため、名（下の名前）を入力してください。",
        "no-match-v2": "この名前では見つかりませんでした。綴りを確認するか、受付窓口にお問い合わせください。",
        "still-ambiguous-v2": "まだ特定できませんでした。受付窓口にお問い合わせください。",
        "select-error-v2": "うまくいきませんでした。もう一度お試しください。"
      },
      "card-checkin": {
        "title": "チェックインを確認",
        "subtitle": "データが正常に読み取られました。",
        "confirm": "チェックインを確認"
      },
      "register-from-card": {
        "title": "新規登録",
        "subtitle": "まだシステムに登録されていません。登録しますか？",
        "card-data": "カードデータ",
        "create": "登録する",
        "create-error": "登録に失敗しました。もう一度お試しいただくか、スタッフにお問い合わせください。",
        "staff-assist": "コールスタッフ",
        "no-card-data-title": "カードデータがありません",
        "no-card-data": "カードからデータを読み取ることができません。",
        "insurance-verified": "保険確認済み: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "カードの情報",
        "subtitle-v2": "情報をご確認ください。間違いがあれば「変更」をタップしてください。",
        "create-v2": "情報を確定",
        "create-error-v2": "受付できませんでした。もう一度お試しいただくか、受付窓口にお問い合わせください。",
        "insurer-missing-v2": "カードに健康保険の情報がありません。受付窓口にお問い合わせください。",
        "edit": "変更",
        "name": "氏名",
        "insurer": "健康保険"
      },
      "patient-lookup": {
        "title": "患者を検索",
        "subtitle": "お名前または保険番号を入力してください。",
        "lastname": "姓",
        "lastname-placeholder": "あなたの姓",
        "dob": "生年月日",
        "firstname": "名",
        "firstname-placeholder": "あなたの名前",
        "search": "検索",
        "searching": "検索中...",
        "search-placeholder": "名前または保険番号...",
        "results-placeholder": "検索結果がここに表示されます",
        "found": "患者発見！",
        "confirm-identity": "ご自身が表示されている患者様であることをご確認ください。",
        "confirm-button": "それが私です",
        "ambiguous-firstname": "複数の患者が見つかった。あなたの名を入力してください。",
        "ambiguous-additional": "複数の患者が見つかった。スタッフまでお問い合わせください。",
        "disambiguation-hint": "これは、お客様を明確に識別するのに役立ちます。",
        "not-found": "これらの詳細を備えた患者は見つかりませんでした。",
        "error": "検索エラー:{{message}}",
        "staff-assist": "スタッフに電話をかける",
        "not-found-prompt": "見つかりませんか？",
        "register-new": "新規登録",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "カードなしで受付",
        "subtitle-firstname": "名（下の名前）も入力してください。",
        "ambiguous-firstname-v2": "この姓の方が複数います。名（下の名前）も入力してください。",
        "search-again": "もう一度検索",
        "found-v2": "見つかりました",
        "found-confirm": "「本人です」で確認してください。",
        "not-found-title": "見つかりませんでした",
        "not-found-check": "綴りと生年月日をご確認ください。受付スタッフがお手伝いします。",
        "not-found-reception": "綴りと生年月日を確認するか、受付窓口にお問い合わせください。",
        "ambiguous-additional-v2": "特定できませんでした。受付窓口にお問い合わせください。",
        "error-v2": "検索できませんでした。もう一度お試しください。"
      },
      "checking-in": {
        "title": "しばらくお待ちください。チェックイン中です。",
        "subtitle": "あなたを治療キューに追加し、チームに通知します。",
        "step-insurance": "保険チェック済み",
        "step-appointment": "予約が確認されました",
        "step-waitlist": "待機リストに追加する",
        "error": "チェックインに失敗しました。もう一度試してください。",
        "continue": "とにかく続けてください",
        "title-v2": "少々お待ちください",
        "loading": "受付しています …",
        "subtitle-v2": "待合リストに登録し、スタッフに知らせています。",
        "error-title": "うまくいきませんでした",
        "error-v2": "受付を完了できませんでした。",
        "error-body": "もう一度お試しください。それでもうまくいかない場合は受付窓口がお手伝いします。"
      },
      "appointment-selection": {
        "title": "予定を選択",
        "subtitle": "今日はいくつかの予定があります。 1 つお選びください。",
        "checking-in": "チェックイン中...",
        "time": "{{time}}",
        "error-v2": "この予約の受付ができませんでした。もう一度お試しいただくか、受付窓口にお問い合わせください。"
      },
      "no-appointment": {
        "title": "予定が見つかりませんでした",
        "subtitle": "今日はあなたとの約束が見つかりませんでした。定期的にご予約ください。",
        "book-appointment": "予約する",
        "book-appointment-description": "通常のスケジューラを通じて新しい予定を予約します。",
        "staff-assist": "スタッフに電話をかける",
        "staff-assist-description": "助けが必要です。",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "本日のご予約は見つかりませんでした。",
        "book-v2": "新しく予約する",
        "book-v2-description": "空いている時間を選んでください。",
        "have-appointment": "予約があります",
        "have-appointment-description": "受付スタッフがお手伝いします。",
        "unavailable-title": "予約は受付窓口でお取りください",
        "subtitle-unavailable": "本日のご予約は見つかりませんでした。受付窓口にお問い合わせください。"
      },
      "staff-assist": {
        "title": "スタッフに通知されました",
        "subtitle": "スタッフがすぐにお手伝いいたします。",
        "message": "ここでお待ちください。スタッフがすぐに伺います。",
        "start-over": "スタートに戻る",
        "auto-redirect": "{{seconds}} 秒後にスタートに戻ります..."
      },
      "eeb-prompt": {
        "title": "保険を確認",
        "title-failed": "確認失敗",
        "subtitle": "保険をどのように確認しますか？",
        "subtitle-failed": "保険アプリでQRコードをスキャンして確認をリクエストしてください。",
        "verify-card": "電子確認",
        "verify-card-description": "保険会社にリクエストを送信します。",
        "select-insurer": "保険会社を選択",
        "select-insurer-description": "保険会社を手動で選択します。",
        "skip": "スキップ",
        "eyebrow-chip": "代替案",
        "eyebrow": "チェックイン・保険証（eEB）",
        "recommended": "おすすめ",
        "qr-title": "保険アプリでスキャン",
        "qr-description": "健康保険アプリを開いてコードをスキャンします。eEB は当社に直接送信されます。",
        "qr-address-label": "送信先",
        "title-app": "アプリで証明",
        "subtitle-app": "健康保険から証明書を直接送ってもらうこともできます。終わったら「次へ」をタップしてください。"
      },
      "quarterly-check": {
        "title": "保険確認",
        "checking": "現在の保険確認を確認中...",
        "error": "確認を実行できません。",
        "title-v2": "あなたの保険",
        "checking-v2": "保険を確認しています – 少々お待ちください。",
        "error-body": "受付は完了しています。保険については受付窓口が一緒に確認します。"
      },
      "insurer-prefilled": {
        "title": "健康保険",
        "subtitle": "今四半期の保険を確認してください。",
        "your-insurance": "あなたの保険",
        "last-read": "最終確認：{{date}}",
        "quarterly-notice": "請求のため、今四半期の現在の保険証明が必要です。",
        "confirm-button": "はい、これが私の保険です",
        "change-button": "別の保険があります",
        "contact-title": "補償範囲の電子証明をリクエストする",
        "contact-description": "保険会社に電話して、次の電子補償証明書をリクエストしてください。",
        "contact-patient": "患者",
        "contact-kim-address": "医療機関の KIM アドレス",
        "contact-phone": "電話",
        "question": "こちらがあなたの健康保険ですか？",
        "quarterly-notice-v2": "四半期に一度、健康保険の証明書が必要です。"
      },
      "insurer-search": {
        "title": "健康保険を選択",
        "subtitle": "法定健康保険を検索して選択してください。",
        "placeholder": "保険を検索...",
        "hint": "検索するには最低2文字入力してください。",
        "no-results": "保険が見つかりません。",
        "no-results-hint": "スペルを確認するか、別の検索をお試しください。",
        "label": "健康保険の名称",
        "search-error-v2": "検索できませんでした。もう一度お試しください。",
        "app-alternative": "健康保険のアプリを使いますか？"
      },
      "insurer-contact": {
        "title": "保険証のリクエスト",
        "subtitle": "次のオプションのいずれかを選択してください。",
        "or": "または",
        "option-eeb-title": "電子的にリクエストする",
        "option-eeb-description": "法定の例外に該当する場合、ご同意の後にリクエストを診療所チームへ引き渡すことができます。",
        "option-qr-title": "アプリでスキャン",
        "option-qr-description": "保険アプリで QR code をスキャンします。",
        "option-call-title": "自分に電話してください",
        "option-call-description": "保険会社に電話し、この医療機関宛ての eEB を依頼してください:",
        "phone": "電話",
        "phone-not-available": "保険証に記載されている電話番号",
        "patient-name": "患者",
        "practice-kim": "医療機関の KIM アドレス",
        "help-notice": "お困りのことがございましたら、受付までお越しください。",
        "submit-eeb-button": "今すぐリクエスト",
        "contacted-button": "電話しました",
        "contacted-button-countdown": "電話の時間です ({{seconds}})",
        "go-to-counter-button": "受付へ行く",
        "qr-continue-button": "スキャンしました",
        "qr-continue-button-countdown": "スキャンにかかる時間 ({{seconds}}s)",
        "title-v2": "健康保険の証明書",
        "subtitle-v2": "健康保険のアプリを使うのが一番簡単です。",
        "subtitle-no-app": "健康保険から証明書をどの方法で送ってもらうか選んでください。",
        "option-eeb-description-v2": "当院があなたに代わって健康保険に依頼します。そのためにあなたの同意が必要です。",
        "call-instruction": "健康保険に電話して、証明書を当院に送るよう依頼してください。",
        "call-instruction-practice": "健康保険に電話して、証明書を{{practice}}に送るよう依頼してください。",
        "done-button": "完了 – 次へ",
        "done-button-countdown": "完了 – 次へ（あと{{seconds}}秒）"
      },
      "eeb-consent": {
        "title": "同意",
        "subtitle": "電子保険確認のための同意が必要です。",
        "insurance": "あなたの保険",
        "consent-title": "電子保険確認の同意（eEB）",
        "consent-text": "健康保険が、保険証明として私の保険データ (例: 氏名、生年月日、保険番号) を安全な KIM 通信サービス経由で医療機関 {{practiceName}} に送信することを理解しています。この送信に同意します。この同意は、治療に影響を与えることなくいつでも撤回できることを理解しています。",
        "withdrawal-notice": "この同意はいつでも撤回できます。",
        "agree-button": "同意します",
        "decline-button": "キャンセル",
        "treatment-notice": "この同意は治療に影響しません。",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "健康保険の証明書",
        "summary": "健康保険から証明書が直接当院に届きます。そのためにあなたの同意が必要です。",
        "confirm-first": "まず宣言を確認してください。"
      },
      "qr-code": {
        "title": "保険アプリでスキャン",
        "instruction-1": "保険アプリを開いてこのQRコードをスキャンしてください。",
        "instruction-2": "その後、医療機関が保険確認を自動的に受け取ります。",
        "practice": "医療機関: {{name}}",
        "alternative-hint": "代替：保険アプリを使用",
        "instruction-app": "健康保険のアプリを開いて、このコードを読み取ってください。証明書が直接当院に届きます。",
        "staff-line": "医院スタッフ用: {{address}}",
        "staff-line-practice": "医院スタッフ用: {{name}} · {{address}}",
        "alternative-app": "健康保険のアプリでも証明書を依頼できます: アプリを開いてこのコードを読み取ってください。"
      },
      "register-basics": {
        "title": "個人情報",
        "subtitle": "詳細を入力してください。",
        "family-name": "姓",
        "given-name": "名",
        "dob": "生年月日",
        "gender": "性別",
        "insurance-type": "保険タイプ",
        "insurer-name": "加入している保険の名前",
        "insurer-name-placeholder": "例:デベカ、DKV、アリアンツ…",
        "gender-required": "いずれかを選んでください。"
      },
      "register-insurer": {
        "title": "健康保険",
        "subtitle": "健康保険を選択してください。",
        "search-placeholder": "保険を検索..."
      },
      "register-details": {
        "title": "概要",
        "subtitle": "情報を確認してください。",
        "create": "登録を完了",
        "missing-data": "すべての必須フィールドに入力してください。",
        "create-error": "登録に失敗しました。もう一度試してください。",
        "policy-number": "ポリシー番号 (オプション)",
        "policy-number-placeholder": "保険証券番号",
        "create-v2": "受付を完了",
        "policy-number-hint": "番号は保険証に記載されています。"
      },
      "diff-review": {
        "eyebrow-chip": "レビュー",
        "eyebrow": "チェックイン・カードデータ",
        "title": "データ比較",
        "subtitle": "カードデータと記録の間に相違が見つかりました。",
        "col-current": "現在の記録",
        "col-new": "カードからの新規",
        "new-badge": "新しい",
        "field-fallback": "フィールド",
        "note": "更新されたデータは、正確な請求と緊急時の連絡に役立ちます。",
        "comparison-placeholder": "比較がここに表示されます",
        "confirm": "変更を確認",
        "apply-error": "データを適用できませんでした。もう一度試してください。",
        "retry": "もう一度試してください",
        "skip": "とにかく続けてください",
        "no-changes": "変更が見つかりません",
        "title-v2": "情報が変わりました",
        "subtitle-v2": "カードに新しい情報があります。反映しますか？",
        "confirm-v2": "反映して受付",
        "keep": "変更せずに受付",
        "col-current-v2": "これまで",
        "col-new-v2": "カードの新しい情報",
        "value-yes": "はい",
        "value-no": "いいえ"
      },
      "insurance-selection": {
        "title": "保険タイプ",
        "subtitle": "保険タイプを選択してください。",
        "gkv": "法定保険",
        "gkv-description": "法定健康保険の加入者。",
        "pkv": "民間または自費",
        "pkv-description": "民間保険または自費。",
        "pkv-description-v2": "民間医療保険、または自費でお支払い。"
      },
      "eeb-request": {
        "title": "リクエストを受け付けました",
        "subtitle": "受付を完了できます。{{insurer}} からの回答は後ほど診療所に届きます。",
        "verifying": "リクエストは直ちに処理するため受理されました。",
        "success": "リクエストは診療所チームに安全に引き渡されました。",
        "error": "リクエストの確認を利用できません。",
        "try-alternative": "代替方法",
        "kim-load-error": "医療機関の KIM アドレスを読み込めませんでした。",
        "kim-label": "医療機関 · KIM",
        "non-blocking-note": "これは健康保険への到達やご加入状況をまだ確認するものではありません。",
        "auto-continue": "{{seconds}}秒後に自動的に進みます。",
        "unavailable-title": "うまくいきませんでした",
        "unavailable-v2": "健康保険への申請を記録できませんでした。",
        "unavailable-body": "健康保険のアプリで証明書を送ってもらうか、受付窓口で手続きしてください。",
        "use-app": "アプリで",
        "at-reception": "受付窓口で手続き"
      },
      "self-pay": {
        "title": "自費",
        "subtitle": "自費患者として治療を受けます。",
        "info": "治療費用はご自身の負担となることにご注意ください。",
        "confirm": "理解しました",
        "title-v2": "自費でお支払い",
        "subtitle-v2": "治療費はご自身でお支払いいただきます。",
        "insured-after-all": "やはり保険に加入しています"
      },
      "done": {
        "title": "完了！",
        "subtitle": "チェックインが完了しました。",
        "finish": "終了",
        "done-label": "完了",
        "error-label": "お知らせ",
        "eyebrow": "チェックイン・完了",
        "queue-label": "待合室",
        "queue-title": "お座りください",
        "queue-meta": "個別にお電話させていただきます。",
        "success-title": "チェックイン成功！",
        "success-subtitle": "待合室にお座りください。お呼びします。",
        "auto-redirect": "まもなくスタートページにリダイレクトされます...",
        "auto-redirect-countdown": "{{seconds}} 秒後にスタートに戻ります...",
        "card-expired-title": "カード期限切れ",
        "card-expired-subtitle": "健康保険カードの有効期限が切れています。",
        "card-expired-info": "スタッフにお問い合わせください。",
        "back-to-start": "スタートに戻る",
        "anamnesis-title": "完全な病歴フォーム",
        "anamnesis-description": "QR code をスキャンすると、スマートフォンで簡単に病歴フォームに記入できます。",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "受付が完了しました",
        "card-expired-info-v2": "受付窓口にお問い合わせください。"
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "情報を確認する",
          "balance-prefix": "保存すると:",
          "balance-direct-v2": "すぐに保存: {{count}}",
          "balance-reception-v2": "受付が確認: {{count}}",
          "chip-reception-v2": "変更は受付が確認します",
          "chip-changed": "変更: {{count}}",
          "remove": "削除",
          "example-email": "例: name@example.jp",
          "example-phone": "例: 090 1234 5678",
          "intro-v2": "受付は完了しています。この情報はまだ正しいですか？確認は任意です。",
          "auto-hide": "表示した内容は少し経つと再び隠れます。"
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "この情報は受付に伝えました。",
          "banner-done-v2": "ありがとうございます。情報を受け取りました。",
          "footer-v2": "その他の情報は変わりません。"
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "プライバシー保護のため、表示を閉じました。受付は完了しています。変更はいつでも受付窓口にお伝えください。"
        }
      },
      "progress": {
        "identify": "受付",
        "insurance": "保険",
        "done": "完了"
      },
      "dob-format-hint": "例: 01.10.1980",
      "dob-required": "生年月日を入力してください。",
      "insurance-label": {
        "GKV": "公的保険",
        "PKV": "民間保険",
        "SELFPAY": "自費"
      }
    },
    "emergency": {
      "title": "緊急事態！",
      "label": "緊急時",
      "subtitle": "このアラームはこの場所でのみ鳴り、救助要請は行われていません。急性または生命を脅かす可能性のある緊急時は112番に電話してください。",
      "call-emergency": "緊急サービスに電話する (112)",
      "stop-sound": "音を止める",
      "play-sound": "サウンドを再生する",
      "back-to-start": "スタートに戻る",
      "headline": "すぐに受付のスタッフに声をかけてください。命に危険がある場合は112に電話してください。"
    },
    "help-reception": "受付の手伝い",
    "help-reception-toast": "受付までお問い合わせください。喜んでお手伝いさせていただきます。",
    "language-entry": {
      "title": "言語を選択してください"
    },
    "loading": "読み込み中…",
    "step-progress-label": "進行状況",
    "step-progress-phase": "セクション {{current}} / {{total}}：{{phase}}",
    "step-progress-substep": "パート {{current}} / {{total}}",
    "step-progress-complete": "完了",
    "identification": {
      "title": "どなたですか？",
      "lead": "健康保険証を使うのが最も早い方法です。お名前で検索することもできます。",
      "lead-card-only": "健康保険証をカードリーダーに差し込んでください。",
      "mode-label": "どの方法で受付しますか？",
      "mode-card": "カードで",
      "mode-search": "名前で検索",
      "mode-create": "初めての受診",
      "card": {
        "loading": "カードリーダーを準備しています …",
        "checking": "カードリーダーを確認しています …",
        "insert-title": "健康保険証をカードリーダーに差し込んでください。",
        "insert-detail": "情報は自動で読み取ります。",
        "detected": "カードを検出しました",
        "read": "カードを読み取る",
        "reading": "カードを読み取っています …",
        "reading-hint": "カードは差し込んだままにしてください。",
        "no-terminal-title": "カードリーダーを利用できません",
        "help-with-search": "お名前で検索するか、受付でお尋ねください。",
        "help-reception": "受付でお尋ねください。喜んでお手伝いします。",
        "unreadable-title": "カードを検出しましたが、読み取れません",
        "error-title": "カードを読み取れませんでした",
        "not-unique": "このカードではご本人を特定できませんでした。お名前で検索するか、受付でお尋ねください。",
        "no-match": "このカードに一致する情報が見つかりませんでした。お名前で検索するか、受付でお尋ねください。",
        "without-card": "カードなしで進む"
      },
      "lookup": {
        "lead": "姓と生年月日を入力してください。",
        "first-name": "名",
        "last-name": "姓",
        "dob": "生年月日",
        "dob-hint": "形式：日.月.年",
        "search": "検索",
        "confirm": "はい、本人です",
        "found-title": "見つかりました",
        "found-body": "ご本人であることを確認してください。",
        "first-name-needed-title": "名を入力してください",
        "first-name-needed-body": "ご本人を特定するためです。その後「検索」をタップしてください。",
        "ambiguous-title": "ご本人を特定できませんでした",
        "ambiguous-body": "受付でお尋ねください。喜んでお手伝いします。",
        "not-found-title": "一致する情報が見つかりません",
        "not-found-body": "入力内容をご確認ください。",
        "error-title": "現在検索できません",
        "error-body": "もう一度お試しいただくか、受付でお尋ねください。"
      },
      "create": {
        "insurance-question": "保険の種類は？",
        "insurance-required": "保険の種類を選択してください。",
        "error-title": "情報を保存できませんでした",
        "error-body": "もう一度お試しいただくか、受付でお尋ねください。"
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "最初にロックを解除します",
      "subtitle": "FrontDesk+ は練習用ソフトウェアでアクティブ化する必要があります。",
      "step1": "SolStore で注文します (または、Doc-Cirrus パートナーが注文します)。",
      "step2": "アクティベーション後、「inSuite Sols」（管理者権限）下のinSuiteでアクティベートしてください。",
      "step3": "Bridge管理→「デバイスの追加」を開きます。",
      "cta": "すべて完了しました - 次に進みます"
    },
    "welcome": {
      "title": "このデバイスを練習に追加します",
      "scan": "コードの写真を撮ります",
      "prepare-link": "inSuite にコードがありませんか?",
      "language": "言語"
    },
    "scan": {
      "requesting": "カメラへのアクセスが要求されています…",
      "scanning": "コードにカメラを向けます",
      "paste": "代わりに貼り付けます",
      "manual-title": "手動で接続する",
      "manual-description": "QR コードが利用できない場合は、Bridge 管理から接続データを取得します。",
      "address-label": "Bridgeアドレス",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "SOLTOKENを挿入",
      "manual-submit": "接続を引き継ぐ",
      "error-title": "コードが認識されない",
      "camera-denied-title": "カメラへのアクセスが拒否されました",
      "camera-denied-hint": "設定でカメラへのアクセスを許可して、もう一度お試しください。",
      "retry": "もう一度やり直してください"
    },
    "preflight": {
      "title": "設置されます",
      "all-green": "すべてのテストに合格しました",
      "practice": "練習する",
      "device-name": "デバイス名",
      "device-name-placeholder": "例えばB. 受付1",
      "card-reader": "カードリーダー",
      "pin": "新しい秘密番号",
      "pin-placeholder": "4桁のPIN",
      "finish": "仕上げる",
      "recheck": "もう一度確認してください",
      "diagnosis": "診断ID",
      "checklist-error": "Bridgeが接続を拒否したか、到達できません。SOLTOKENとBridgeのアドレスを確認してください。",
      "checklist-retry": "再確認",
      "edit-token": "SOLTOKENを変更",
      "rescan": "コードを再スキャン"
    },
    "persisting": "設定を保存しています …",
    "success": {
      "title": "デバイスが追加されました",
      "detail": "このデバイスは練習用 PC に登場しました。",
      "starting": "患者モードが開始されます…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "練習ソフトとの接続",
        "fix": "Bridge 接続とサーバーアドレスを確認してください。"
      },
      "missing_insuite_url": {
        "label": "inSuiteアドレス",
        "fix": "QR コードをもう一度スキャンします。アドレスがありません。"
      },
      "missing_server_token": {
        "label": "サーバートークン",
        "fix": "QR コードをもう一度スキャンします。トークンがありません。"
      },
      "missing_gateway_session": {
        "label": "Gateway セッション",
        "fix": "再度ログインします - セッションが見つかりません。"
      },
      "missing_gateway_enrollment": {
        "label": "デバイスの登録",
        "fix": "Gateway にデバイスを登録します。"
      },
      "gateway_not_ready": {
        "label": "Gateway の準備完了",
        "fix": "Gateway がセットアップを完了するまで待ちます。"
      },
      "token_verification_failed": {
        "label": "トークンチェック",
        "fix": "サーバートークンまたはBridge接続を確認してください。"
      },
      "session_expired": {
        "label": "ミーティング",
        "fix": "セッションの有効期限が切れました - 再度ログインしてください。"
      },
      "device_revoked": {
        "label": "デバイスのステータス",
        "fix": "このデバイスはブロックされています。練習場に連絡してください。"
      },
      "missing_practice_name": {
        "label": "練習名",
        "fix": "医療行為名を読み込めませんでした (inSuite)."
      },
      "missing_device_name": {
        "label": "デバイス名",
        "fix": "デバイス名を入力してください。"
      },
      "telematik_unavailable": {
        "label": "テレマティクスインフラストラクチャ",
        "fix": "オプション — TI が利用可能になり次第、カード チェックが引き続き可能になります。"
      },
      "selected_card_reader_unavailable": {
        "label": "カードリーダー",
        "fix": "オプション — カードリーダーを選択または接続します。"
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "オプション - 医療行為資格カードを挿入します (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKENを入力",
      "description": "セキュリティ上の理由により、QRコードにはSOLTOKENが含まれていません。inSuiteの「Sol-Aktivierung」(FrontDesk+)でコピーし、ここに貼り付けてください。",
      "submit": "続行",
      "rescan": "コードを再スキャン"
    }
  }
}
